module.exports = "<div class=\"app-loading-bar animate fadeIn\">\n  <div class=\"progress\">\n    <div class=\"indeterminate\"></div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/loading-bar/loading-bar.component.html
// module id = ./src/app/core/components/loading-bar/loading-bar.component.html
// module chunks = main